import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@offerzen/pinata-shame'

import styles from './styles'

const DescriptionList = ({ children }) => {
  return (
    <Text>
      <dl className={styles.list}>{children}</dl>
    </Text>
  )
}

DescriptionList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default DescriptionList
